import CrmSystemBalanceAPI from '../../../api/crm/CrmSystemBalanceAPI';
import { CURRENCY_PUZZLE } from '../../constants/systemBalance';
import { moneyFormatToSting } from '../../helpers/MoneyHelpers';
import SystemBalanceDefaultModel from '../../models/SystemBalanceDefaultModel';

const state = {
  systemBalances: [],
  isLoading: false,
};

const getters = {
  systemBalances: (state) => {
    return state.systemBalances;
  },
  currentPuzzleBalance: (state) => {
    const puzzleBalance = state.systemBalances.find((el) => el.code = CURRENCY_PUZZLE);

    if (!puzzleBalance) {
      return '-';
    }

    return moneyFormatToSting(puzzleBalance.amount_after);
  },
};

const actions = {
  current({ state, commit }) {
    if (state.isLoading) {
      return;
    }

    commit('setIsLoading', true);
    return new Promise((resolve, reject) => {
      CrmSystemBalanceAPI.getCurrentSystemBalance()
        .then(response => {
          commit('setSystemBalances', response.data);
          resolve(response);
        })
        .catch((e) => {
          this.isLoading = false;
          reject(e);
        })
        .finally(() => {
          commit('setIsLoading', false);
        });
    });
  },
};

const mutations = {
  setSystemBalances(state, systemBalances) {
    state.systemBalances = [];
    systemBalances.forEach((item) => {
      state.systemBalances.push({
        ...SystemBalanceDefaultModel(),
        ...item,
      });
    });
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
